import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cda482a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "copyright-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " Copyright © " + _toDisplayString(new Date().getFullYear()||'') + " 四川润泽皓宇科技有限公司 蜀ICP备2022005652号 ", 1))
}